/**
 * Stripe cost check campaign form — a thin wrapper over the schema-driven
 * <LeadForm> (src/forms/definitions/stripeCostCheck.jsx). Routed to Sam;
 * no marketing opt-in by brief.
 */
import LeadForm from "@/forms/engine/LeadForm";
import { LottieSuccess } from "@/components/LottieAnimations";
import stripeCostCheck from "@/forms/definitions/stripeCostCheck";

const CONTEXT = {
  campaign: "Stripe cost check",
  enquiry_contact: "Sam",
  note: "Business using Stripe, requesting a free review of their online payment costs. May be an existing CanDo customer or new to CanDo — the form does not ask.",
};

// Rendered only after the API accepts the enquiry — the pack requires this
// ("Display only when the implementation can truthfully confirm receipt").
function SuccessMessage() {
  return (
    <div className="text-center py-12 space-y-4" data-testid="scc-form-success" role="status" aria-live="polite">
      <LottieSuccess size={80} className="mx-auto" />
      <h3 className="font-heading text-2xl font-bold text-brand-black">{stripeCostCheck.success.title}</h3>
      <p className="text-brand-grey max-w-md mx-auto leading-relaxed">{stripeCostCheck.success.body}</p>
    </div>
  );
}

export default function StripeCostCheckForm() {
  return <LeadForm schema={stripeCostCheck} context={CONTEXT} renderSuccess={() => <SuccessMessage />} />;
}
